import React, { useEffect } from "react";

import useNfc from "../../hooks/useNfc";
import useSimplePopup from "../../hooks/useSimplePopup";
import { useDeviceType } from "../../hooks/useDeviceType/Index";

import NfcImage from "../../assets/img/nfc.png";

type Props = {
  onClose?: () => void;
  onResult?: (result: any, error?: any) => void;
};

export default function NFCReader({ onClose, onResult }: Props) {
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [result, handleNfc] = useNfc({
    open: (message: string) => {
      open(message, { onClick: () => onClose?.() });
    },
  });
  const deviceType = useDeviceType();

  useEffect(() => {
    if (result.isLoading === false) {
      if (result.result && result.result !== "unsupported") {
        open(result.result);
        handleNfc.off();
        onResult?.(result.result);
        onClose?.();
      } else if (result.result === "unsupported") {
        onClose?.();
      }
    }
  }, [result.isLoading, result.result]);

  useEffect(() => {
    // open("NFC 태그를 읽지 못했어요", { buttonText: "NFC 태그 재시도" });
    // open("대여를 신청한 장소가 아닙니다.\n대여 장소를 확인해주세요");
    if (deviceType === "Android") {
      handleNfc.on();
    } else if (deviceType === "iOS") {
      handleNfc.call();
    }
  }, [deviceType]);

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center gap-14">
      <div className=" whitespace-pre-line text-center text-xl font-semibold">
        {"휴대폰 뒷면을\nNFC태그에 가까이 두세요"}
      </div>
      <img src={NfcImage} alt="nfc" className="h-[320px] w-[320px]" />
      <div
        className="fixed top-[60px] right-5 z-30"
        onClick={() => onClose?.()}
      >
        <NFCCloseIcon />
      </div>
      {simplePopupComponent}
    </div>
  );
}

export const NFCCloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="black"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="black"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
